import { Component } from '@angular/core';

@Component({
	selector: 'mb-model-list-skeleton',
	templateUrl: './model-list-skeleton.component.html',
	styleUrls: ['./model-list-skeleton.component.scss']
})
export class ModelListSkeletonComponent {

	public GHOST_ROWS = Array(5).fill(0);
	public MODEL_ROWS = Array(2).fill(0);

}
